import Vue from "vue"
import Router from "vue-router"
Vue.use(Router)

function waitForTwilight(to, from, next){
    let salla = Vue.prototype.$salla || window.salla || window.Salla || {};
    return new Promise(resolve => {salla?.onReady(() => salla.lang?.onLoaded(resolve));})
    .then(() => {next()})
    .catch(() => {next()});
}

const router = new Router({
    mode: 'history',
    base: window.location.pathname,
    routes: [
        {
            path: "/",
            name: "home",
            component: () => import("@/components/Checkout"),
            beforeEnter: (to, from, next) => {
                waitForTwilight(to, from, next);
            }
        },
        {
            path: "/address",
            name: "address",
            component: () => import("@/components/Address")
        },  
        {
            path: "/thank-you/:id",
            name: "complete",
            component: () => import("@/components/Complete")
        },
        {
            path: "/error",
            name: "error",
            component: () => import("@/components/Error"),
            props: true,
            beforeEnter: (to, from, next) => {
                waitForTwilight(to, from, next);
            }
        },
        // Fallback route (catch-all)
        {
            path: "*",
            component: () => import("@/components/NotFound")
        }
    ]
})

export default router
